import "./Header.scss";
import { useState } from "react";
import Modal from "../Modal/Modal";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as Apple } from "../../assets/apple.svg";
import About from "../About/About";
import Contact from "../Contact/Contact";
import DownloadInfos from "../DownloadInfos/DownloadInfos";

function Header() {
  const [showAbout, setShowAbout] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <nav className="header wrapper">
        <div className="container nav">
          <div className="logo">
            <Logo />
          </div>
          <ul className="nav-list">
            <li>
              <p
                onClick={(e) => {
                  e.preventDefault();
                  setShowAbout(true);
                }}
              >
                About
              </p>
            </li>
            <li>
              <p
                onClick={(e) => {
                  e.preventDefault();
                  setShowContact(true);
                }}
              >
                Contact
              </p>
            </li>
            <li>
              <div
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDownload(true);
                }}
              >
                <Apple />
                Download beta
              </div>
            </li>
          </ul>
          <button className="burger" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
        </div>
        <Modal isOpen={menuOpen} onClose={() => setMenuOpen(false)} noHeader>
          <div className="menu-links">
            <p
              onClick={() => {
                setShowAbout(true);
                setMenuOpen(false);
              }}
            >
              About
            </p>
            <p
              onClick={() => {
                setShowContact(true);
                setMenuOpen(false);
              }}
            >
              Contact
            </p>
            <div
              className="btn"
              onClick={(e) => {
                e.preventDefault();
                setShowDownload(true);
              }}
            >
              Download beta
            </div>
          </div>
        </Modal>
      </nav>
      <Modal isOpen={showAbout} size="large" onClose={() => setShowAbout(false)} title="About me">
        <About
          onRequestContact={() => {
            setShowAbout(false);
            setShowContact(true);
          }}
        />
      </Modal>
      <Modal
        isOpen={showContact}
        size="large"
        onClose={() => setShowContact(false)}
        title="Contact"
      >
        <Contact />
      </Modal>
      <Modal
        isOpen={showDownload}
        size="large"
        onClose={() => setShowDownload(false)}
        title="How to install Flowcam"
      >
        <DownloadInfos
          onRequestContact={() => {
            setShowDownload(false);
            setShowContact(true);
          }}
        />
      </Modal>
    </>
  );
}

export default Header;
